import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_130_add_purchase_order: any[] = [
  {
      "componentType": "screenGroup",
      "title": "Purchase order",
      "style": {},
      "childComponents": [
          {
              "componentType": "form",
              "Name": "pur_ord_add",
              "TableName": "purchase_order",
              "columnNumber": "m1 t1 w1",
              "style": {
                  "padding": 10,
                  "backgroundColor": "#ffffff",
                  "direction": "column"
              },
              "Fields": [
                  {
                      "componentType": "fieldGroup",
                      "Label": "Purchase order details",
                      "BindValue": "con_purchase_order_details",
                      "style": {
                          "direction": "column"
                      },
                      "childComponents": [
                          {
                              "componentType": "textField",
                              "name": "txt_purchaseno",
                              "label": "Purchase order No.",
                              "placeholder": "Will be auto generated...",
                              "required": false,
                              "inputType": "text",
                              "disabled": true,
                              "Json_Attribute": "purchase_order_no",
                              "BindValue": "txt_purchaseno",
                              "AutoPopulate": true,
                              "AutoPopulate_format": "PURORD_[******]"
                          },
                          {
                              "componentType": "dateField",
                              "name": "txt_Purchase_date",
                              "label": "Purchase date",
                              "placeholder": "",
                              "required": true,
                              "DefaultToday": true,
                              "Json_Attribute": "purchase_order_date",
                              "BindValue": "txt_Purchase_date",
                              "validation": [
                                  {
                                      "rule": "required",
                                      "message": "Purchase date is required"
                                  }
                              ]
                          },
                          {
                              "componentType": "searchableDropdown",
                              "name": "drp_supplier",
                              "label": "Vendor",
                              "placeholder": "",
                              "required": true,
                              "lookupName": "supplier",
                              "options": [],
                              "Json_Attribute": "supplier_id",
                              "BindValue": "drp_supplier",
                              "validation": [
                                  {
                                      "rule": "required",
                                      "message": "Vendor is required"
                                  }
                              ]
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_payment_term",
                              "label": "Payment term",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "disabled": false,
                              "Json_Attribute": "payment_term",
                              "BindValue": "txt_payment_term"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_mobile",
                              "label": "Mobile",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "disabled": false,
                              "Json_Attribute": "mobile_no",
                              "BindValue": "txt_mobile",
                              "BindParent": {
                                  "drp_supplier": "mobile_no"
                              }
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_billingaddress",
                              "label": "Address",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "disabled": true,
                              "Json_Attribute": "billing_address",
                              "BindValue": "txt_billingaddress",
                              "BindParent": {
                                  "drp_supplier": "address"
                              }
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_trn",
                              "label": "TRN",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "disabled": true,
                              "Json_Attribute": "vendor_taxregno",
                              "BindValue": "txt_trn",
                              "BindParent": {
                                  "drp_supplier": "taxregno"
                              }
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_remarks",
                              "label": "Remarks",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "Json_Attribute": "remarks",
                              "BindValue": "txt_remarks"
                          }
                      ]
                  },
                  {
                      "componentType": "subModule",
                      "name": "purchase_order_details",
                      "label": "Purchase details",
                      "tableName": "purchase_order_details",
                      "parentField": "drp_supplier",
                      "BindValue": "jobcard_details",
                      "childControls": [
                          {
                              "componentType": "searchableDropdown",
                              "name": "drp_product",
                              "label": "Code",
                              "placeholder": "",
                              "required": false,
                              "lookupName": "product_itemcode",
                              "options": [],
                              "searchable": true,
                              "clearable": true,
                              "Json_Attribute": "product_id",
                              "BindValue": "drp_product"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_itemname",
                              "label": "Item name",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "Json_Attribute": "item_name",
                              "disabled": false,
                              "BindValue": "txt_itemname",
                              "BindParent": {
                                  "drp_product": "item_name"
                              }
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_rate",
                              "label": "Rate",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "rate",
                              "disabled": false,
                              "BindValue": "txt_rate",
                              "ExpressionV2": "[drp_product.purchase_rate]"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_qty",
                              "label": "Qty",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "qty",
                              "BindValue": "txt_qty"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_unit_discount",
                              "label": "Unit discount",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "unit_discount",
                              "disabled": false,
                              "BindValue": "txt_unit_discount",
                              "validation": [
                                  {
                                      "rule": "condition",
                                      "condition": "[txt_unit_discount] <= [txt_rate]",
                                      "message": "Unit discount cannot be greater than rate"
                                  }
                              ]
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_line_discount",
                              "label": "Total discount",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "line_discount",
                              "disabled": true,
                              "BindValue": "txt_line_discount",
                              "ExpressionV2": "[txt_unit_discount] * [txt_qty]"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_amount",
                              "label": "Amount",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "amount",
                              "disabled": true,
                              "BindValue": "txt_amount",
                              "ExpressionV2": "[txt_rate] * [txt_qty]"
                          },
                          {
                              "componentType": "selectDropdown",
                              "name": "drp_vat",
                              "label": "VAT%",
                              "placeholder": "",
                              "required": false,
                              "lookupName": "tax_rates",
                              "options": [],
                              "defaultValue": "1",
                              "Json_Attribute": "vat_id",
                              "BindValue": "drp_vat"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_vat_amt",
                              "label": "Vat amt",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "vat_amt",
                              "disabled": true,
                              "BindValue": "txt_vat_amt",
                              "ExpressionV2": "([txt_amount] - [txt_line_discount]) * ([drp_vat.taxrate]/100)"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_net_amt",
                              "label": "Net amount",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "net_amt",
                              "disabled": true,
                              "BindValue": "txt_net_amt",
                              "ExpressionV2": "([txt_amount] - [txt_line_discount]) + [txt_vat_amt]"
                          }
                      ],
                      "FooterControls": [
                          {
                              "componentType": "textField",
                              "BindValue": "txt_one",
                              "IncludeLabel": false,
                              "IsReadOnly": true,
                              "style": {
                                  "display": "none"
                              }
                          },
                          {
                              "componentType": "textField",
                              "BindValue": "txt_2",
                              "IncludeLabel": false,
                              "IsReadOnly": true,
                              "style": {
                                  "display": "none"
                              }
                          },
                          {
                              "componentType": "textField",
                              "BindValue": "txt_3",
                              "IncludeLabel": false,
                              "IsReadOnly": true,
                              "style": {
                                  "display": "none"
                              }
                          },
                          {
                              "componentType": "textField",
                              "BindValue": "txt_4",
                              "IncludeLabel": false,
                              "IsReadOnly": true,
                              "style": {
                                  "display": "none"
                              }
                          },
                          {
                              "IncludeLabel": false,
                              "Label": "Amount",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_sub_amount",
                              "Json_Attribute": "amount",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsReadOnly": true,
                              "ExpressionV2": "[SUM:txt_amount]",
                              "IsVerticalView": true,
                              "inputType": "number",
                              "Default_Value": "0"
                          },
                          {
                              "IncludeLabel": false,
                              "Label": "Total discount",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "purchase_line_discount_total",
                              "Json_Attribute": "line_discount_total",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsReadOnly": true,
                              "ExpressionV2": "[SUM:txt_line_discount]",
                              "IsVerticalView": true,
                              "inputType": "number",
                              "Default_Value": "0"
                          },
                          {
                              "IncludeLabel": false,
                              "Label": "VAT amount",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "spare_vat_amount",
                              "Json_Attribute": "vat_amount",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsReadOnly": true,
                              "ExpressionV2": "[SUM:txt_vat_amt]",
                              "IsVerticalView": true,
                              "inputType": "number",
                              "Default_Value": "0"
                          },
                          {
                              "IncludeLabel": false,
                              "Label": "Amount",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_sub_net_amount",
                              "Json_Attribute": "net_amount",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsReadOnly": true,
                              "ExpressionV2": "[SUM:txt_net_amt]",
                              "IsVerticalView": true,
                              "inputType": "number",
                              "Default_Value": "0"
                          }
                      ]
                  }
              ]
          },
          {
              "componentType": "button",
              "name": "Submit",
              "onPressAction": "save",
              "style": {
                  "backgroundColor": "#22c55e"
              }
          }
      ]
  }
];
